import BaseUseCase from "../../base_use_case.js";

class UpdateCurrentUserQuestionnaireUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "put",
      url: `/api/v1/users/questionnaires/current_user`,
      data: this.wrapParams(params, "questionnaire")
    });
  }
}

const instance = new UpdateCurrentUserQuestionnaireUseCase();
export default instance;